import { Box, FormControlLabel, Switch, TextField } from '@material-ui/core';
import React from 'react';
import { useSelector } from 'react-redux';
import { calendarOptions, tripData } from 'src/redux/Calendar/sliceCalendar';
import {
  IOptionDetails,
  IOtionDetailsValue,
} from 'src/redux/Calendar/interfaces';
import { getPlaceholderFromDefaultValues } from 'src/helpers/calendar/getNormalisedValueFromInput';
import { useStyles } from './styles';

interface IOptionMaster extends Omit<IOptionDetails, 'calendar_id' | 'values'> {
  disable_sell_change: 0 | 1;
  values: {
    value_id: string;
    price: null | string;
    is_disabled: null | string;
    apply_tax: null | string;
  }[];
}

export const OptionsBulkForm = ({
  state,
  setState,
}: {
  state: IOptionMaster;
  setState: React.Dispatch<React.SetStateAction<IOptionMaster>>;
}) => {
  const classes = useStyles();
  const { option_type } = useSelector(calendarOptions);
  const data = useSelector(tripData);
  const defaultOption = data?.additional_options.find(
    (i) => i.id === option_type
  );

  if (!defaultOption || !state) return null;

  const changeState = (data: Partial<IOptionMaster>) => {
    setState((prev) => ({ ...prev, ...data }));
  };
  const changeStateValues = (
    data: Partial<IOtionDetailsValue>,
    idx: number
  ) => {
    setState((prev) => ({
      ...prev,
      values: prev.values.map((i, pos) => ({
        ...i,
        ...(pos === idx && data),
      })),
    }));
  };

  const toggleFields = () => {
    setState((prev) => ({
      ...prev,
      disable_sell_change: prev.disable_sell_change ? 0 : 1,
      is_disabled: '0',
    }));
  };

  return (
    <Box>
      <Box
        display="flex"
        width={1}
        justifyContent="center"
        alignItems="center"
        flexWrap="wrap"
        gridGap="10px">
        <Box pr={4}>
          <Box display="flex" alignItems="center" py={1} position="relative">
            <FormControlLabel
              control={<Switch className={classes.customSwitch} />}
              label="Disable Option"
              disabled={!!state.disable_sell_change}
              checked={Boolean(state.is_disabled && +state.is_disabled)}
              onChange={(_, checked) =>
                changeState({ is_disabled: checked ? '1' : '0' })
              }
            />
            <Box
              style={{
                position: 'absolute',
                cursor: 'pointer',
                opacity: '0.7',
                bottom: '-20px',
                left: 0,
                display: 'inline-block',
                textDecoration: 'underline',
              }}
              onClick={() => toggleFields()}>
              {!!state.disable_sell_change ? 'Make changes' : "Don't change"}
            </Box>
          </Box>
        </Box>
        <Box py={2}>
          {state.values.map((i, idx) => (
            <Box
              key={i.value_id}
              display="flex"
              justifyContent="space-between"
              flexWrap="wrap"
              gridGap="10px"
              py={1.5}
              borderTop={idx ? '0.8px solid rgba(0, 0, 0, 0.12)' : undefined}>
              <Box
                mx={4}
                display="flex"
                alignItems="center"
                fontWeight={500}
                minWidth={'100px'}>
                {defaultOption.values.find((o) => o.id === +i.value_id)?.name ||
                  '-'}
              </Box>
              <Box mr={2} display="flex" alignItems="center">
                <TextField
                  type="number"
                  placeholder={getPlaceholderFromDefaultValues(
                    defaultOption.values.find((o) => o.id === +i.value_id)
                      ?.price || 0,
                    2
                  )}
                  value={i.price || ''}
                  onChange={(e) =>
                    changeStateValues({ price: e.target.value }, idx)
                  }
                  variant="outlined"
                  InputProps={{
                    style: {
                      background: '#fff',
                      borderRadius: '4px',
                      width: '120px',
                    },
                  }}
                  size="small"
                  InputLabelProps={{
                    shrink: true,
                    style: {
                      letterSpacing: '0.04em',
                    },
                  }}
                  label="Price"
                />
              </Box>
              <Box display="flex">
                <Box display="flex" alignItems="center" mr={4}>
                  <FormControlLabel
                    control={<Switch className={classes.customSwitch} />}
                    label="Disable"
                    checked={Boolean(i.is_disabled && +i.is_disabled)}
                    onChange={(_, checked) =>
                      changeStateValues(
                        { is_disabled: checked ? '1' : '0' },
                        idx
                      )
                    }
                  />
                </Box>
                {/* <Box display="flex" alignItems="center">
                  <FormControlLabel
                    control={<Switch className={classes.customSwitch} />}
                    label="Apply Tax"
                    checked={Boolean(i.apply_tax && +i.apply_tax)}
                    onChange={(_, checked) =>
                      changeStateValues({ apply_tax: checked ? '1' : '0' }, idx)
                    }
                  />
                </Box> */}
              </Box>
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  );
};
